export default [
    {
        path: '/accounting/open-invoice-list/:filter?',
        name: 'open_invoice_list',
        component: () => import('@src/accounting-document/open-invoice-list.vue'),
        meta: {
            title: 'Offene Rechnungen',
            role: 'ROLE_LIST_INVOICE',
        },
    },
    {
        path: '/accounting/invoice-search',
        name: 'invoice_search',
        component: () => import('@src/accounting-document/invoice-search.vue'),
        meta: {
            title: 'Rechnungen',
            role: 'ROLE_SHOW_INVOICE',
        },
    },
    {
        path: '/accounting/invoice-list/:filter?',
        name: 'invoice_list',
        component: () => import('@src/accounting-document/invoice-list.vue'),
        meta: {
            title: 'Alle Rechnungen',
            role: 'ROLE_LIST_INVOICE',
        },
    },
    {
        path: '/accounting/invoice/:id?',
        name: 'invoice',
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/accounting-document/invoice.vue'),
        meta: {
            role: 'ROLE_SHOW_INVOICE',
        },
    },
    {
        path: '/accounting/credit-note-list/:filter?',
        name: 'credit_note_list',
        component: () => import('@src/accounting-document/credit-note-list.vue'),
        meta: {
            title: 'Alle Korrekturrechnungen',
            role: 'ROLE_LIST_CREDIT_NOTE',
        },
    },
    {
        path: '/accounting/credit-note-search',
        name: 'credit_note_search',
        component: () => import('@src/accounting-document/credit-note-search.vue'),
        meta: {
            title: 'Korrekturrechnungen',
            role: 'ROLE_SHOW_CREDIT_NOTE',
        },
    },
    {
        path: '/accounting/credit-note/:id?',
        name: 'credit_note',
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/accounting-document/credit-note.vue'),
        meta: {
            role: 'ROLE_SHOW_CREDIT_NOTE',
        },
    },
    {
        path: '/accounting/delivery-note-search',
        name: 'delivery_note_search',
        component: () => import('@src/accounting-document/delivery-note-search.vue'),
        meta: {
            title: 'Lieferscheine',
            role: 'ROLE_SHOW_DELIVERY_NOTE',
        },
    },
    {
        path: '/accounting/delivery-note/:id',
        name: 'delivery_note',
        props(route) {
            return { id: Number.parseInt(route.params.id) };
        },
        component: () => import('@src/accounting-document/delivery-note.vue'),
        meta: {
            role: 'ROLE_DELIVERY_NOTE_DETAIL',
        },
    },
    {
        path: '/accounting/incoming-credit-note-search',
        name: 'incoming_credit_note_search',
        component: () => import('@src/accounting-document/incoming-credit-note-search.vue'),
        meta: {
            title: 'Eingangsgutschriften',
            role: 'ROLE_LIST_INCOMING_CREDIT_NOTE',
        },
    },
    {
        path: '/accounting/incoming-credit-note-list/:filter?',
        name: 'incoming_credit_note_list',
        component: () => import('@src/accounting-document/incoming-credit-note-list.vue'),
        meta: {
            title: 'Offene Eingangsgutschr.',
            role: 'ROLE_LIST_INCOMING_CREDIT_NOTE',
        },
    },
    {
        path: '/accounting/incoming-credit-note/:id?',
        name: 'incoming_credit_note',
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/accounting-document/incoming-credit-note.vue'),
        meta: {
            role: 'ROLE_SHOW_INCOMING_CREDIT_NOTE',
        },
    },
    {
        path: '/accounting/quote-list/:filter?',
        name: 'quote_list',
        component: () => import('@src/accounting-document/quote-list.vue'),
        meta: {
            title: 'Kostenvoranschläge',
            role: 'ROLE_SHOW_QUOTE',
        },
    },
    {
        path: '/accounting/quote/:id?',
        name: 'quote',
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        component: () => import('@src/accounting-document/quote.vue'),
        meta: {
            role: 'ROLE_SHOW_QUOTE',
        },
    },
];
